export default __webpack_public_path__ + "static/media/Y_Ybyra.8677ac41.svg";